import { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, asField } from 'informed';
import { Button, ButtonOutlined, FieldInput, Alert } from 'platfi-ui-components';
import * as Validators from 'utils/Validators';
import EmailClientSuccess from './EmailClientSuccess';

import emailTemplate from './emailTemplate.json';

const FieldInputAsField = asField(FieldInput);

export default class EmailClientTab extends Component {
  static propTypes = {
    email: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    sendEmailInvite: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
  };

  state = {
    form: {
      message: emailTemplate.message,
      fromEmail: this.props.email,
    },
    success: false,
    error: false,
  };

  onSubmit = (values) => {
    this.props
      .sendEmailInvite(values)
      .then(() => this.setState({ success: true }))
      .catch(() => this.setState({ error: true }));
  };

  onClickSendAnother = () => {
    this.setState((prevState) => ({ success: !prevState.success }));
  };

  renderForm = (error) => (
    <Form initialValues={this.state.form} onSubmit={this.onSubmit}>
      {({ formState }) => (
        <div className="o-modal-form">
          {error && (
            <Alert className="o-modal-form__alert" label="We couldn’t submit your request" error />
          )}
          <FieldInputAsField label="From" type="email" field="fromEmail" validateOnBlur />
          <FieldInputAsField
            label="To"
            type="text"
            field="name"
            validate={Validators.buildValidator('name', Validators.required())}
            validateOnBlur
          />
          <FieldInputAsField
            label="Client email address"
            type="email"
            field="toEmail"
            validate={Validators.buildValidator('toEmail', Validators.email())}
            validateOnBlur
          />
          <FieldInputAsField
            label="Text"
            field="message"
            validate={Validators.buildValidator('message', Validators.required())}
            validateOnBlur
            isTextArea
            cols="50"
            rows="20"
          />

          <div className="u-align-right o-modal-form__actions">
            <ButtonOutlined
              className="o-modal-form__action"
              onClick={this.props.closeModal}
              label="Cancel"
              large
              secondary
            />
            <Button
              className="o-modal-form__action"
              type="submit"
              label="Send"
              large
              primary
              disabled={formState.invalid}
            />
          </div>
        </div>
      )}
    </Form>
  );

  render() {
    const { closeModal } = this.props;
    const { success, error } = this.state;

    return success ? (
      <EmailClientSuccess
        onClickSendAnother={this.onClickSendAnother}
        closeModal={closeModal}
        onSuccess={success}
      />
    ) : (
      this.renderForm(error)
    );
  }
}
